import React from "react";
import { B2CLockerSellingOrderCartItem } from "../Order";
import { makeStyles, Typography } from "@material-ui/core";

interface IOrderItemCard {
	item: B2CLockerSellingOrderCartItem;
}

export const OrderItemCard: React.FC<IOrderItemCard> = (props) => {
	if (!props.item) {
		return null;
	}

	const classes = style();
	const { item } = props;

	return (
		<div className={classes.root}>
            <div className={classes.image} style={{ backgroundImage: `url(${item.photoUrl})` }}></div>
			<div className={classes.textRow}>
				<Typography variant="body2" className={classes.text}>{item.label}</Typography>
				<Typography variant="body2" className={classes.text}>x&nbsp;{item.quantity}</Typography>
			</div>
		</div>
	);
};

const style = makeStyles((theme) => ({
	root: {
		width: "100%",
		background: theme.palette.background.paper,
		padding: "5px 12px",
		borderRadius: "4px",
		minHeight: "50px",
		boxShadow: theme.shadows[1],
		display: "flex",
		flexDirection: "column",
		justifyContent: "center",
		alignItems: "center",
        position: "relative",
        overflow: "hidden"
	},
	textRow: {
		display: "flex",
		flexDirection: "row",
		justifyContent: "space-between",
		alignItems: "center",
		gap: "16px",
        width: "100%",
        paddingLeft: "40px"
	},
    text:{
        display: "-webkit-box",
        WebkitLineClamp: 2,
		WebkitBoxOrient: "vertical",
		overflow: "hidden",
        maxWidth: "85%",
    },
    image:{
        height: "130%",
		aspectRatio: "1/1",
		backgroundSize: "cover",
		backgroundRepeat: "no-repeat",
		backgroundPosition: "center center",
		borderRadius: "200px",
		position: "absolute",
		left: "-20px",
    }
}));
